import React from 'react'

import {SidebarMenuItems} from '../types'
import {MenuNavItem} from './MenuNavItem'

interface MenuProps {
  items: SidebarMenuItems[];
  onMenuItemClick?: () => void;
}

export const Menu = ({items, onMenuItemClick}: MenuProps) => {
  return (
    <div>
      {items.map((item, id) =>
        <div key={`nav-link-${id}`} onClick={onMenuItemClick} className={`${item.hidden && 'hidden'}`}>
          <MenuNavItem to={item.url} icon={item.icon} title={item.name} />
        </div>
      )}
    </div>
  )
}
